import type {
  HomeTestimonioItem,
  HomeTestimoniosBannerRow,
  HomeTestimoniosContent,
} from '../models/home-testimonios-content.model';
import {
  extractYoutubeId,
  toYoutubeEmbedUrl,
  youtubeThumbnailUrl,
} from './home-youtube.util';

const PLACEHOLDER_THUMB =
  'assets/img/Home/testimonios/testimonio-luz.png';

export function mapTestimoniosBannersToContent(
  rows: HomeTestimoniosBannerRow[],
  fallback: HomeTestimoniosContent
): HomeTestimoniosContent {
  const items = rows
    .map((row) => mapRow(row))
    .filter((item): item is HomeTestimonioItem => item !== null)
    .sort((a, b) => a.orden - b.orden);

  return {
    eyebrow: fallback.eyebrow,
    title: fallback.title,
    items: items.length ? items : fallback.items,
  };
}

function mapRow(row: HomeTestimoniosBannerRow): HomeTestimonioItem | null {
  const tipo = (row.tipoBanner ?? '').trim();
  if (tipo !== 'Video' && tipo !== 'VideoEncuesta') {
    return null;
  }
  const orden = Number(row.orden ?? Number.NaN);
  if (!Number.isFinite(orden) || orden < 1) {
    return null;
  }

  const esEncuesta = tipo === 'VideoEncuesta';
  const embedUrl = esEncuesta ? null : toYoutubeEmbedUrl(row.urlForward);
  const mediaUrl = esEncuesta
    ? (row.urlArchivo?.trim() || null)
    : null;

  if (!esEncuesta && !embedUrl) {
    return null;
  }
  if (esEncuesta && !mediaUrl) {
    return null;
  }

  // Existentes sin los 3 campos: se muestran con fallback (script/admin los completa).
  // Nuevos desde admin siguen siendo obligatorios al guardar.
  const name =
    (row.titulo ?? '').trim() ||
    (row.nombreArchivo ?? '').trim() ||
    'Usuario neocrédito';
  const role =
    (row.nombreBoton ?? '').trim() || 'Negocio neocrédito';
  const quote =
    (row.contenido ?? '').trim() ||
    'Conoce la experiencia de este usuario con neocrédito.';

  const ytId = extractYoutubeId(row.urlForward);
  let thumbnailUrl = PLACEHOLDER_THUMB;
  if (!esEncuesta && ytId) {
    thumbnailUrl = youtubeThumbnailUrl(ytId);
  }

  return {
    idBanner: row.idBanner ?? null,
    orden,
    name,
    role,
    quote,
    tipoBanner: tipo,
    embedUrl,
    thumbnailUrl,
    mediaUrl,
    imageAlt: `Testimonio de ${name}`,
  };
}
